import { useState } from "react";
import { Share, SquarePlus, Smartphone, X } from "lucide-react";
import { isIOS, isStandalone } from "@/lib/push";

const KEY = "qhh.iosHint.dismissed";

export function IosSteps() {
  return (
    <div className="rounded-xl border p-4" style={{ borderColor: "rgba(var(--st-amber),0.35)", background: "rgba(var(--st-amber),0.07)" }} data-testid="ios-install-hint">
      <p className="flex items-center gap-2 text-sm font-bold text-q-text" data-testid="ios-install-hint-text">
        <Smartphone className="h-4 w-4 flex-shrink-0" style={{ color: "rgb(var(--st-amber))" }} />
        On iPhone and iPad, add The Queue to your Home Screen to get notifications
      </p>
      <ol className="mt-3 space-y-1.5 text-sm text-q-muted" data-testid="ios-install-steps">
        <li className="flex items-center gap-2"><span className="font-black text-q-text">1.</span> Tap <Share className="inline h-4 w-4" /> Share in Safari's toolbar.</li>
        <li className="flex items-center gap-2"><span className="font-black text-q-text">2.</span> Choose <SquarePlus className="inline h-4 w-4" /> "Add to Home Screen", then Add.</li>
        <li className="flex items-center gap-2"><span className="font-black text-q-text">3.</span> Open The Queue from your Home Screen and turn on notifications in My account.</li>
      </ol>
    </div>
  );
}

export default function IosInstallBanner() {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  if (hidden || !isIOS() || isStandalone()) return null;
  return (
    <div className="relative px-4 pt-3 sm:px-8">
      <IosSteps />
      <button className="absolute right-5 top-4 inline-flex h-11 w-11 items-center justify-center rounded-full text-q-faint hover:text-q-text sm:right-9" aria-label="Dismiss"
        onClick={() => { sessionStorage.setItem(KEY, "1"); setHidden(true); }} data-testid="ios-install-hint-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
}
